const adminUrl = `/api/bonuses/admin/`
export default {
  admin: {
    getAll: `${adminUrl}getall`,
    getFilters: `${adminUrl}getfilters`
  }
}
